import { render, staticRenderFns } from "./SubscribeLayout.vue?vue&type=template&id=297c32d1"
import script from "./SubscribeLayout.vue?vue&type=script&lang=js"
export * from "./SubscribeLayout.vue?vue&type=script&lang=js"
import style0 from "./SubscribeLayout.vue?vue&type=style&index=0&id=297c32d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports